<template>
  <div v-if="obra">
    <v-row :class="{ 'flex-column-reverse': vuetify?.breakpoint.smAndDown }">
      <v-col>
        <TabelaLocalizacao
          v-if="obra.localizacaoList"
          class="mt-1 mb-2"
          :items="obra.localizacaoList"
        />

        <v-row dense>
          <Info cols="6" label="Classificação" :value="obra.deClassificacao" />

          <Info
            cols="6"
            label="Notação do autor"
            :value="obra.deNotacaoAutor"
          />
        </v-row>

        <v-row dense>
          <Info
            cols="6"
            label="Localização fixa"
            :value="obra.deLocalizacaoFixa"
          />

          <Info label="Autor(es)" :value="obra.autorList" />
        </v-row>

        <v-row dense>
          <Info cols="6" label="Autor entidade" :value="obra.deAutorEntidade" />
          <Info
            cols="6"
            label="Autor(es) secundário(s)"
            :value="obra.autorSecundarioList"
          />
        </v-row>

        <v-row dense>
          <Info cols="6" label="Título" :value="obra.deTituloSubtitulo" />
          <Info cols="6" label="Edição" :value="obra.deEdicao" />
          <Info
            cols="6"
            label="Publicações"
            :value="formatarPublicacoes(obra.obraEditoraList)"
          />
          <Info cols="6" label="Série/Coleção" :value="obra.deSerieColecao" />
          <Info cols="12" label="Idioma(s)" :value="obra.idiomaList" />
          <Info cols="6" label="ISBN" :value="obra.cdIsbn" />
          <template v-if="obra.sumario">
            <Info
              cols="12"
              label="Sumário"
              value="Clique aqui para visualizar"
              link
              @click:value="
                download(
                  'Sumário - ' + obra.deTituloSubtitulo + '.pdf',
                  obra.sumario
                )
              "
            />
          </template>
        </v-row>
      </v-col>
      <v-col v-if="obra.capa" cols="12" md="4" class="d-flex">
        <CapaLivro :base64-content="obra.capa" />
      </v-col>
    </v-row>
    <v-row dense>
      <Info
        cols="12"
        highlighted
        hide-bullet-point
        header="Notas Gerais"
        :value="obra.notaList"
      />

      <Info
        cols="12"
        highlighted
        data-testid="info-disponivel-em"
        header="Disponível em:"
        :value="obra.deSite"
        link
        :href="obra.deSite"
        target="_blank"
        class="break-url"
      />

      <Info cols="12" highlighted header="Assunto(s)" :value="obra.assuntos" />

      <v-col cols="12">
        <TabelaCapitulos />
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import Info from '@/components/DynamicInfo.vue';
import CapaLivro from './CapaLivro.vue';
import TabelaLocalizacao from './TabelaLocalizacao.vue';
import TabelaCapitulos from './TabelaCapitulos.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { formatarPublicacoes } from '@/utils/util';
import { useVuetify } from '@/composables/useVuetify';
import { download } from '@/utils/downloadDocs';

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);

</script>

<style scoped>
:deep(.break-url a) {
  word-break: break-all;
  white-space: normal;
  overflow-wrap: break-word;
}
</style>
